module.exports = '<svg width="44" height="32" viewBox="0 0 44 32"><path d="M14.584 31.432l-14-13.668a1.892 1.892 0 0 1 0-2.736l2.828-2.736a2.055 2.055 0 0 1 2.828 0L16 21.868 37.756.568a2.055 2.055 0 0 1 2.828 0l2.828 2.736c.78.752.78 1.98 0 2.732l-26 25.404a2.055 2.055 0 0 1-2.828-.008z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/checkmark-1.js
// module id = 1059
// module chunks = 14